import { useRef, useState } from "react";

const MAILTO =
  "mailto:reggateway@aoshearman.com?subject=Request%20Demo%20%26%20Free%20Trial%20of%20RegGateway&body=Please%20contact%20me%20to%20schedule%20a%20demo%20of%20RegGateway.";

const AVATAR_FALLBACK =
  "data:image/svg+xml;utf8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2274%22 height=%2274%22%3E%3Crect width=%2274%22 height=%2274%22 fill=%22%23d9dde1%22/%3E%3Ctext x=%2237%22 y=%2246%22 font-family=%22Arial%22 font-size=%2226%22 fill=%22%23425563%22 text-anchor=%22middle%22%3ESB%3C/text%3E%3C/svg%3E";

export default function Landing({ onLogin }) {
  const videoRef = useRef(null);
  const [posterHidden, setPosterHidden] = useState(false);

  const playVideo = () => {
    setPosterHidden(true);
    const v = videoRef.current;
    if (v) v.play().catch(() => {});
  };

  return (
    <>
      <section className="rg-hero">
        <div className="rg-hero__panel" aria-hidden="true">
          <svg
            className="rg-hero__circuit"
            viewBox="0 0 600 700"
            preserveAspectRatio="xMidYMid slice"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g stroke="#55636f" strokeWidth="2" fill="none">
              <path d="M40 60 H180 V140 H320 V60 H460" />
              <path d="M120 700 V520 H260 V420 H120" />
              <path d="M480 700 V560 H360 V460 H520 V300" />
              <path d="M40 300 H160 V360 H300" />
              <path d="M560 120 H420 V220 H540" />
              <path d="M300 420 V520 H460" />
              <path d="M200 240 V340 H80" />
            </g>
            <g fill="#55636f">
              <circle cx="40" cy="60" r="6" />
              <circle cx="460" cy="60" r="6" />
              <circle cx="120" cy="700" r="6" />
              <circle cx="480" cy="700" r="6" />
              <circle cx="520" cy="300" r="6" />
              <circle cx="300" cy="420" r="6" />
              <circle cx="540" cy="220" r="6" />
              <circle cx="80" cy="340" r="6" />
              <circle cx="300" cy="360" r="6" />
              <circle cx="460" cy="520" r="6" />
              <circle cx="40" cy="300" r="6" />
            </g>
          </svg>
        </div>

        <div className="rg-container">
          <div className="rg-hero__inner">
            <div className="rg-hero__copy">
              <p className="rg-hero__eyebrow">The Regulatory Change Solution</p>
              <h1 className="rg-hero__title">
                Ensure Regulatory Compliance with RegGateway
              </h1>
              <p className="rg-hero__lead">
                RegGateway as a Software as a Service helps you manage financial
                regulatory compliance effectively.
              </p>
              <div className="rg-hero__cta">
                <a className="rg-btn rg-btn--slate" href={MAILTO}>
                  Request Demo
                </a>
                <button
                  className="rg-btn rg-btn--accent"
                  type="button"
                  href="#login"
                  onClick={(e) => {
                    e.preventDefault();
                    onLogin();
                  }}
                >
                  Login to RegGateway
                </button>
              </div>
            </div>

            <div className="rg-hero__device">
              <div className="rg-laptop">
                <div className="rg-laptop__screen">
                  <video
                    ref={videoRef}
                    className="rg-laptop__video"
                    playsInline
                    controls
                    preload="metadata"
                    onPlay={() => setPosterHidden(true)}
                    onEnded={() => setPosterHidden(false)}
                  >
                    <source
                      src="https://lexemostore.blob.core.windows.net/lex-prd-uploads/2021/03/RegGateway-Marketing-Website-1080p-Folk-45fps-V3.mp4"
                      type="video/mp4"
                    />
                  </video>
                  <button
                    type="button"
                    className={
                      "rg-laptop__poster" + (posterHidden ? " is-hidden" : "")
                    }
                    aria-label="Play video"
                    onClick={playVideo}
                  >
                    <span className="rg-wordmark">A&O SHEARMAN</span>
                    <span className="rg-laptop__play" aria-hidden="true">
                      <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </span>
                  </button>
                </div>
                <div className="rg-laptop__base" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="rg-brand">
        <div className="rg-container">
          <span className="rg-wordmark">A&O SHEARMAN</span>
          <p className="rg-brand__tagline">
            Combining high legal expertise with technology
          </p>
        </div>
      </section>

      <section className="rg-testimonial">
        <div className="rg-container">
          <blockquote className="rg-testimonial__quote">
            "With RegGateway we have an amazing tool for ensuring regulatory
            compliance. It covers horizon scanning, the implementation process
            and also knowledge sharing within the team."
          </blockquote>
          <div className="rg-testimonial__person">
            <img
              className="rg-testimonial__avatar"
              alt="Dr Stefan Brügmann"
              width="74"
              height="74"
              loading="lazy"
              src="https://lexemostore.blob.core.windows.net/lex-prd-uploads/2021/01/Dr-Stefan-Bruegmann-150x150.jpg"
              srcSet="https://lexemostore.blob.core.windows.net/lex-prd-uploads/2021/01/Dr-Stefan-Bruegmann-150x150.jpg 150w, https://lexemostore.blob.core.windows.net/lex-prd-uploads/2021/01/Dr-Stefan-Bruegmann-300x300.jpg 300w, https://lexemostore.blob.core.windows.net/lex-prd-uploads/2021/01/Dr-Stefan-Bruegmann.jpg 400w"
              sizes="74px"
              onError={(ev) => {
                const img = ev.currentTarget;
                img.onerror = null;
                img.removeAttribute("srcset");
                img.src = AVATAR_FALLBACK;
              }}
            />
            <span>
              <span className="rg-testimonial__name">Dr Stefan Brügmann</span>
              <br />
              <span className="rg-testimonial__role">
                General Counsel, Helaba
              </span>
            </span>
          </div>
        </div>
      </section>

      <section className="rg-section rg-support">
        <div className="rg-container">
          <h2 className="rg-section__title">How can RegGateway support me?</h2>

          <div className="rg-support__grid">
            <div className="rg-support__item">
              <div className="rg-support__icon">
                <svg width="58" height="58" viewBox="0 0 64 64">
                  <ellipse cx="42" cy="18" rx="14" ry="5" />
                  <path
                    d="M28 18v8c0 2.8 6.3 5 14 5s14-2.2 14-5v-8"
                    fill="none"
                    stroke="var(--slate)"
                    strokeWidth="3"
                  />
                  <path
                    d="M28 26v8c0 2.8 6.3 5 14 5s14-2.2 14-5v-8"
                    fill="none"
                    stroke="var(--slate)"
                    strokeWidth="3"
                  />
                  <circle cx="20" cy="40" r="16" />
                  <text
                    x="20"
                    y="47"
                    fontFamily="Arial"
                    fontSize="20"
                    fontWeight="bold"
                    fill="#fff"
                    textAnchor="middle"
                  >
                    $
                  </text>
                </svg>
              </div>
              <h5 className="rg-support__name">Cost and Time Savings</h5>
              <p className="rg-support__text">
                Spend less time on cumbersome processes and prioritise quickly.
              </p>
            </div>

            <div className="rg-support__item">
              <div className="rg-support__icon">
                <svg width="54" height="58" viewBox="0 0 64 64">
                  <rect x="29" y="8" width="6" height="48" />
                  <path d="M35 12h16l6 7-6 7H35z" />
                  <path d="M29 26H13l-6 7 6 7h16z" />
                  <rect x="20" y="54" width="24" height="5" rx="2" />
                </svg>
              </div>
              <h5 className="rg-support__name">Simplified Regulation</h5>
              <p className="rg-support__text">
                Simplify regulation and manage regulatory compliance more
                effectively.
              </p>
            </div>

            <div className="rg-support__item">
              <div className="rg-support__icon">
                <svg
                  width="58"
                  height="58"
                  viewBox="0 0 64 64"
                  fill="none"
                  stroke="var(--slate)"
                  strokeWidth="3"
                >
                  <g strokeLinecap="round">
                    <line x1="32" y1="32" x2="32" y2="12" />
                    <line x1="32" y1="32" x2="49" y2="22" />
                    <line x1="32" y1="32" x2="49" y2="42" />
                    <line x1="32" y1="32" x2="32" y2="52" />
                    <line x1="32" y1="32" x2="15" y2="42" />
                    <line x1="32" y1="32" x2="15" y2="22" />
                  </g>
                  <circle cx="32" cy="32" r="6" fill="var(--slate)" />
                  <circle cx="32" cy="10" r="5" fill="var(--slate)" />
                  <circle cx="51" cy="21" r="5" fill="var(--slate)" />
                  <circle cx="51" cy="43" r="5" fill="var(--slate)" />
                  <circle cx="32" cy="54" r="5" fill="var(--slate)" />
                  <circle cx="13" cy="43" r="5" fill="var(--slate)" />
                  <circle cx="13" cy="21" r="5" fill="var(--slate)" />
                </svg>
              </div>
              <h5 className="rg-support__name">Superior Prioritisation</h5>
              <p className="rg-support__text">
                Be more effective with compliance and administration and focus
                on high-value activities.
              </p>
            </div>
          </div>

          <div className="rg-support__grid rg-support__grid--row2">
            <div className="rg-support__item">
              <div className="rg-support__icon">
                <svg width="58" height="58" viewBox="0 0 64 64">
                  <path d="M32 4l4 6 7-2 1 7 7 2-3 6 5 5-5 5 3 6-7 2-1 7-7-2-4 6-4-6-7 2-1-7-7-2 3-6-5-5 5-5-3-6 7-2 1-7 7 2z" />
                  <circle cx="32" cy="32" r="9" fill="#fff" />
                </svg>
              </div>
              <h5 className="rg-support__name">Automated Processes</h5>
              <p className="rg-support__text">
                Reduce the burden of manual intervention and increase accuracy
                of your regulatory compliance efforts.
              </p>
            </div>

            <div className="rg-support__item">
              <div className="rg-support__icon">
                <svg width="50" height="58" viewBox="0 0 64 64">
                  <path d="M32 6C20 6 12 14 12 25c0 7 4 12 8 16 2 2 3 4 3 7h18c0-3 1-5 3-7 4-4 8-9 8-16C52 14 44 6 32 6z" />
                  <rect x="24" y="55" width="16" height="5" rx="2" />
                  <rect x="27" y="62" width="10" height="2" rx="1" />
                  <g stroke="var(--slate)" strokeWidth="3" strokeLinecap="round">
                    <line x1="32" y1="1" x2="32" y2="-4" />
                  </g>
                </svg>
              </div>
              <h5 className="rg-support__name">Intuitive Usability</h5>
              <p className="rg-support__text">
                Develop your own effective workflow with just a few clicks and
                content filters.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="rg-digital">
        <div className="rg-container">
          <h2 className="rg-digital__title">
            Financial Regulatory Law
            <br />
            goes digital.
          </h2>
          <p className="rg-digital__lead">
            No more Excel spreadsheets or overly complex tools! RegGateway is an
            intuitive solution that helps focus on the essentials and, at the
            same time, is audit-proof.
          </p>
        </div>
      </section>

      <section className="rg-section rg-features">
        <div className="rg-container">
          <h2 className="rg-section__title">The key features of RegGateway</h2>
          <div className="rg-features__grid">
            <article className="rg-card">
              <div className="rg-card__icon">
                <svg
                  width="70"
                  height="80"
                  viewBox="0 0 80 90"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M32 34h16l5 46H27z" />
                  <path d="M30 46h20M28 60h24" />
                  <rect x="30" y="20" width="20" height="14" rx="2" />
                  <path d="M34 20v-6h12v6" />
                  <circle cx="40" cy="10" r="2" />
                  <path d="M22 24l-8-4M58 24l8-4M20 34l-9 0M60 34l9 0M24 15l-6-6M56 15l6-6" />
                </svg>
              </div>
              <h5 className="rg-card__title">
                Horizon Scanning / Regulatory Monitoring
              </h5>
              <p className="rg-card__text">
                Identify new regulatory developments easily and tailored to the
                specific type of regulated firm, so that only relevant changes
                appear.
              </p>
            </article>

            <article className="rg-card">
              <div className="rg-card__icon">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 90 90"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 30a30 30 0 0 1 48-6" />
                  <path d="M68 24l2-10M68 24l-10 1" />
                  <path d="M70 60a30 30 0 0 1-48 6" />
                  <path d="M22 66l-2 10M22 66l10-1" />
                  <path
                    d="M45 34l3 0 1-6 5 2 3-5 4 4-3 5 4 4 6-1 0 5-6 1-1 6-5-2-3 5-4-4 3-5-4-4-6 1 0-5 6-1z"
                    transform="translate(-6 4) scale(0.9)"
                  />
                  <circle cx="45" cy="45" r="6" />
                </svg>
              </div>
              <h5 className="rg-card__title">Implementation Management</h5>
              <p className="rg-card__text">
                Effective implementation (including tailored impact analysis and
                gap analysis) of new legislation and agile control using our
                project management tool (including KPIs).
              </p>
            </article>

            <article className="rg-card">
              <div className="rg-card__icon">
                <svg
                  width="80"
                  height="70"
                  viewBox="0 0 90 80"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M45 22C36 15 24 15 14 18v44c10-3 22-3 31 4" />
                  <path d="M45 22c9-7 21-7 31-4v44c-10-3-22-3-31 4" />
                  <path d="M45 22v46" />
                  <path
                    d="M20 28h18M20 36h18M20 44h18M52 28h18M52 36h18M52 44h18"
                    strokeWidth="2"
                  />
                </svg>
              </div>
              <h5 className="rg-card__title">
                Financial Regulatory Law Sourcebook
              </h5>
              <p className="rg-card__text">
                A comprehensive and categorised collection of all laws in the
                field of financial regulatory law for Europe and Germany
                (constantly being expanded), which can be compiled as an
                obligation register and commented on as desired.
              </p>
            </article>

            <article className="rg-card">
              <div className="rg-card__icon">
                <svg
                  width="76"
                  height="76"
                  viewBox="0 0 90 90"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="38" cy="38" r="26" />
                  <path d="M22 38c5-8 27-8 32 0-5 8-27 8-32 0z" />
                  <circle cx="38" cy="38" r="6" />
                  <line x1="57" y1="57" x2="76" y2="76" />
                </svg>
              </div>
              <h5 className="rg-card__title">
                Change Analysis and Preview of Rules
              </h5>
              <p className="rg-card__text">
                Read the future versions of a law early, including the official
                explanatory memorandum, and identify any legislative changes.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="rg-section rg-audience">
        <div className="rg-container">
          <h2 className="rg-section__title">Who is RegGateway for?</h2>
          <div className="rg-audience__grid">
            <div className="rg-audience__item">
              <div className="rg-audience__icon">
                <svg
                  width="90"
                  height="70"
                  viewBox="0 0 100 80"
                  fill="none"
                  stroke="var(--slate)"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="10,60 30,40 45,52 62,26 80,14" />
                  <circle cx="10" cy="60" r="5" fill="var(--slate)" />
                  <circle cx="30" cy="40" r="5" fill="var(--slate)" />
                  <circle cx="45" cy="52" r="5" fill="var(--slate)" />
                  <circle cx="62" cy="26" r="5" fill="var(--slate)" />
                  <circle cx="80" cy="14" r="5" fill="var(--slate)" />
                </svg>
              </div>
              <p className="rg-audience__label">Investment Firms</p>
            </div>

            <div className="rg-audience__item">
              <div className="rg-audience__icon">
                <svg
                  width="90"
                  height="70"
                  viewBox="0 0 100 80"
                  fill="none"
                  stroke="var(--slate)"
                  strokeWidth="4"
                  strokeLinejoin="round"
                >
                  <rect x="14" y="20" width="72" height="46" rx="6" />
                  <line x1="24" y1="40" x2="46" y2="40" />
                  <line x1="24" y1="50" x2="38" y2="50" />
                </svg>
              </div>
              <p className="rg-audience__label">Credit Institutions</p>
            </div>

            <div className="rg-audience__item">
              <div className="rg-audience__icon">
                <svg
                  width="80"
                  height="70"
                  viewBox="0 0 100 80"
                  fill="none"
                  stroke="var(--slate)"
                  strokeWidth="4"
                  strokeLinejoin="round"
                >
                  <polygon points="50,14 86,32 50,50 14,32" />
                  <polyline points="14,46 50,64 86,46" />
                </svg>
              </div>
              <p className="rg-audience__label">Asset Managers</p>
            </div>

            <div className="rg-audience__item">
              <div className="rg-audience__icon">
                <svg
                  width="80"
                  height="76"
                  viewBox="0 0 100 90"
                  fill="none"
                  stroke="var(--slate)"
                  strokeWidth="4"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                >
                  <rect x="20" y="14" width="34" height="58" rx="5" />
                  <line x1="20" y1="24" x2="54" y2="24" />
                  <line x1="20" y1="62" x2="54" y2="62" />
                  <rect x="52" y="30" width="28" height="34" rx="4" />
                  <path d="M66 52v-8M66 44l-5 5M66 44l5 5" />
                </svg>
              </div>
              <p className="rg-audience__label">Payment Service Providers</p>
            </div>
          </div>
        </div>
      </section>

      <section className="rg-contact">
        <div className="rg-container">
          <h1 className="rg-contact__title">Contact Us</h1>
          <p className="rg-contact__lead">
            If you wish to learn more about RegGateway, please feel free to
            contact us.
          </p>
          <a className="rg-contact__mail" href={MAILTO}>
            <svg
              width="44"
              height="44"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="m2 7 10 6 10-6" />
            </svg>
            <span>Send us an Email</span>
          </a>
        </div>
      </section>

      <footer className="rg-footer">
        <div className="rg-container">
          <p className="rg-footer__copy">© 2026 A&amp;O Shearman</p>
        </div>
      </footer>
    </>
  );
}
